<!--领队报名-->
<template>
  <div>
    <div>
      <van-nav-bar
        title="在线支付"
        left-text="返回"
        left-arrow
        @click-left="onTopClickLeft"
      >
        <a
          :href="
            routeValue === null ||
            routeValue === undefined ||
            routeValue.length === 0
              ? 'https://www.ptty.com.cn/wap/#/'
              : 'https://www.ptty.com.cn/wap/#/' + routeValue
          "
          slot="right"
          style="font-size:20px;"
        >
          <van-icon style="font-size:20px;" name="wap-home" />
        </a>
      </van-nav-bar>
    </div>
    <div style="background: #fff;">
      <div
        style="text-align: center;padding: 10px;font-size: 15px;font-weight: 600;border-bottom: 1px solid #e1e1e1;margin-left: 10px;
    margin-right: 10px;"
      >
        {{ SSMC }}（{{ SSLX }}）
      </div>
    </div>

    <!-- 如果检测到这个人名下有队伍信息，则直接显示列表 -->
    <div style="background: #fff;" v-if="false">
      <div
        style="text-align: center;padding: 10px;font-size: 15px;font-weight: 600;border-bottom: 1px solid #e1e1e1;margin-left: 10px;
    margin-right: 10px;"
      >
        {{ resultXmData.SSMC }}
      </div>
      <van-cell
        v-if="bmLx === 'GR'"
        title="项目"
        :value="
          resultXmData.XMJC +
            '(' +
            (resultXmData.SSLX === 'MS' ||
            resultXmData.SSLX === 'WS' ||
            resultXmData.SSLX === 'XS'
              ? resultXmData.ISXB === 'Y'
                ? resultXmData.SSLXMC
                : '单打'
              : resultXmData.ISXB === 'Y'
              ? resultXmData.SSLXMC
              : resultXmData.SSLXMC) +
            ')'
        "
      />
      <van-field
        v-model="ryInfo.DWQC.VALUE"
        disabled
        label="队伍全称"
        placeholder="请输入队伍全称"
      />
      <van-field
        v-model="ryInfo.DWJC.VALUE"
        disabled
        label="队伍简称"
        placeholder="请输入队伍简称"
      />
      <van-field
        v-if="bmLx === 'TEAM'"
        v-model="ryInfo.LDXM.VALUE"
        disabled
        label="领队姓名"
      />
      <van-field
        v-if="bmLx === 'TEAM'"
        v-model="ryInfo.LDTEL.VALUE"
        disabled
        label="赛事负责人手机号"
      />
      <van-field
        v-if="bmLx === 'TEAM'"
        v-model="BSLXR"
        disabled
        label="比赛联系人"
      />
      <van-field
        v-if="bmLx === 'TEAM'"
        v-model="BSLXRTEL"
        disabled
        label="比赛联系人电话"
      />
      <van-cell
        v-if="resultXmData.ISSF === '1'"
        title="报名费"
        :value="resultXmData.SFJE + '元'"
      />
      <van-cell
        v-if="resultXmData.ISHYMF === '1'"
        title="会员是否优惠"
        :value="'是'"
      />
    </div>
    <loading-com />
  </div>
</template>

<script>
import LoadingCom from "../commonCom/LoadingCom.vue";
export default {
  name: "Pay",
  components: { LoadingCom },
  data() {
    return {
      isWriteShow: false,
      utilPost: "",
      ssid: "",
      op: "wapGL",
      SSMC: "",
      YBMRYLIST: [],
      xmid: "",
      SSLX: "",
      routeValue: ""
    };
  },
  created() {
    this.utilPost = this.$util.handler;
    this.ssid = this.$route.query.ssid;
    this.xmid = this.$route.query.xmid;
  },
  mounted() {
    var routeValue = localStorage.getItem("routeValue");
    this.routeValue = routeValue;
    var openIdEn = localStorage.getItem("openIdEn");
    if (openIdEn === undefined || openIdEn === null || openIdEn.length === 0) {
      this.utilPost.getOpenId(function(openId) {});
    }
    this.mainData();
  },
  methods: {
    mainData() {
      var busData = {
        XMID: this.xmid
      };
      var paramData = {
        headerData: {
          ssid: this.ssid,
          op: this.op, //反射名称
          methodName: "getGrBmxx" //对应的方法名
        },
        busData: busData //参数内容
      };
      this.utilPost.paramData = paramData;
      this.utilPost.sendPost().then(data => {
        if (!data.isSuccess) {
          alert(data.msg);
          return;
        }
        this.YBMRYLIST = data.content.YBMRYLIST;
        this.SSLX = data.content.SSLX;
        this.SSMC = data.content.SSMC;
      });
    },
    onTopClickLeft() {
      this.$router.go(-1);
    },
    onTopClickRight() {
      this.$router.push({
        path: "/addRyInfo",
        query: {
          ssid: this.ssid,
          xmid: this.xmid,
          bmLx: "GR",
          dwid: "",
          czlx: "ADD"
        }
      });
    },
    editorRyInfo(rowItem) {
      this.$router.push({
        path: "/addRyInfo",
        query: {
          ssid: this.ssid,
          xmid: this.xmid,
          bmLx: "GR",
          dwid: "",
          czlx: "UPT",
          ryid1Param: rowItem.RYID1,
          ryid2Param: rowItem.RYID2
        }
      });
    },
    deleteRyxx(itemRow) {
      // alert(JSON.stringify(itemRow));
      if (!confirm("是否删除?")) {
        return;
      }
      var busData = {
        XMID: this.xmid,
        RYID1: itemRow.RYID1,
        RYID2: itemRow.RYID2
      };
      var paramData = {
        headerData: {
          ssid: this.ssid,
          op: this.op, //反射名称
          methodName: "delGrBmxx" //对应的方法名
        },
        busData: busData //参数内容
      };
      this.utilPost.paramData = paramData;
      this.utilPost.sendPost().then(data => {
        alert(data.msg);
        this.mainData();
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.van-button--round {
  height: 35px;
}
.van-card {
  background: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/ReportXm/PayIndex.vue